import styled from 'styled-components';

import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

export const MultipleChoiceListText = styled.div`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}
`;
